export default "__VITE_ASSET__BtxBd2_I__"